// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CompleteTaskRequestModel,
    CreateTaskByAccountDisplayIdRequestModel,
    CreateTaskByAccountIdRequestModel,
    GatewayError,
    NewNoteRequest,
    NoteTaskCompleteResponse,
    NoteTaskCreateByAccountDisplayIdResponse,
    NoteTaskUpdateResponse,
    UpdateTaskRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeNoteApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param newNoteRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async noteCreateNote (newNoteRequest: NewNoteRequest, xProgramId?: string): Promise<AxiosResponse<number>> {
        const _url_ = '/edge/note/v2/note/createNote';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'newNoteRequest' is not null or undefined
        if (newNoteRequest === null || newNoteRequest === undefined) {
            throw new Error('Required parameter newNoteRequest was null or undefined when calling noteCreateNote.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(newNoteRequest, "NewNoteRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<number>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "number");
        }
        return response;
    }
    /**
     * 
     * @param completeTaskRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async taskComplete (completeTaskRequestModel: CompleteTaskRequestModel, xProgramId?: string): Promise<AxiosResponse<NoteTaskCompleteResponse>> {
        const _url_ = '/edge/note/task/complete';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'completeTaskRequestModel' is not null or undefined
        if (completeTaskRequestModel === null || completeTaskRequestModel === undefined) {
            throw new Error('Required parameter completeTaskRequestModel was null or undefined when calling taskComplete.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(completeTaskRequestModel, "CompleteTaskRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskCompleteResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskCompleteResponse");
        }
        return response;
    }
    /**
     * 
     * @param createTaskByAccountDisplayIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async taskCreateByAccountDisplayId (createTaskByAccountDisplayIdRequestModel: CreateTaskByAccountDisplayIdRequestModel, xProgramId?: string): Promise<AxiosResponse<NoteTaskCreateByAccountDisplayIdResponse>> {
        const _url_ = '/edge/note/task/createByAccountDisplayId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createTaskByAccountDisplayIdRequestModel' is not null or undefined
        if (createTaskByAccountDisplayIdRequestModel === null || createTaskByAccountDisplayIdRequestModel === undefined) {
            throw new Error('Required parameter createTaskByAccountDisplayIdRequestModel was null or undefined when calling taskCreateByAccountDisplayId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createTaskByAccountDisplayIdRequestModel, "CreateTaskByAccountDisplayIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskCreateByAccountDisplayIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskCreateByAccountDisplayIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param createTaskByAccountIdRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async taskCreateByAccountId (createTaskByAccountIdRequestModel: CreateTaskByAccountIdRequestModel, xProgramId?: string): Promise<AxiosResponse<NoteTaskCreateByAccountDisplayIdResponse>> {
        const _url_ = '/edge/note/task/createByAccountId';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'createTaskByAccountIdRequestModel' is not null or undefined
        if (createTaskByAccountIdRequestModel === null || createTaskByAccountIdRequestModel === undefined) {
            throw new Error('Required parameter createTaskByAccountIdRequestModel was null or undefined when calling taskCreateByAccountId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(createTaskByAccountIdRequestModel, "CreateTaskByAccountIdRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskCreateByAccountDisplayIdResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskCreateByAccountDisplayIdResponse");
        }
        return response;
    }
    /**
     * 
     * @param updateTaskRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async taskUpdate (updateTaskRequestModel: UpdateTaskRequestModel, xProgramId?: string): Promise<AxiosResponse<NoteTaskUpdateResponse>> {
        const _url_ = '/edge/note/task/update';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'updateTaskRequestModel' is not null or undefined
        if (updateTaskRequestModel === null || updateTaskRequestModel === undefined) {
            throw new Error('Required parameter updateTaskRequestModel was null or undefined when calling taskUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(updateTaskRequestModel, "UpdateTaskRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<NoteTaskUpdateResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "NoteTaskUpdateResponse");
        }
        return response;
    }
}
